import { antBlue, antGrey, runwayColors } from '@/components/styles/globalStyles';
import { Statistic } from '@/types';
import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { TeamOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { createReleaseOverviewRoute } from '@/helpers/routeHelpers';
import Button from 'antd/lib/button';
import { displayReleaseOverviewStatisticLabel } from '@/components/StatCard';
import { displayStatValue } from '@/helpers';
import RightArrowCircledIcon from '@/components/icons/RightArrowCircledIcon';

export interface ReleaseMetricsProps {
    stats: Statistic[];
    orgId: string;
    appId: string;
    releaseId: string;
}

const MAX_STATS = 3;
export const ReleaseMetricsWidget: React.FC<ReleaseMetricsProps> = ({ orgId, appId, releaseId, stats }) => {
    const slicedStats = stats.slice(0, MAX_STATS);
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                alignItems: 'end',
                marginBottom: 20,
                width: '100%',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 8,
                    width: '100%',
                }}
            >
                {slicedStats.map(({ type, value, unit }, index) => {
                    return (
                        <StatisticWidgetCard
                            key={`widgetCard&type=${type}&index=${index}`}
                            title={displayReleaseOverviewStatisticLabel(type, null)}
                            value={typeof value === 'number' ? displayStatValue(type, value, unit) : value}
                        />
                    );
                })}
            </div>
            <Link to={createReleaseOverviewRoute(orgId, appId, releaseId)}>
                <Button type="link" style={{ fontSize: 13, fontWeight: 200, paddingRight: 0 }}>
                    <div
                        style={{
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 8,
                            height: '100%',
                        }}
                    >
                        Release overview
                        <RightArrowCircledIcon />
                    </div>
                </Button>
            </Link>
        </div>
    );
};

export const StatisticWidgetCard: React.FC<{
    title: string;
    value: string;
}> = ({ title, value }) => {
    return (
        <div
            style={{
                borderRadius: 4,
                border: `1px solid ${antGrey.grey5}`,
                backgroundColor: runwayColors.white,
                flex: 1,
                height: 20,
                padding: '8px 12px',
                display: 'flex',
                boxSizing: 'content-box',
                alignItems: 'center',
                gap: 8,
            }}
        >
            <TeamOutlined
                style={{
                    color: antBlue.blue6,
                    fontSize: 12,
                }}
            />
            <Text
                style={{
                    color: antGrey.grey7,
                    fontSize: 12,
                    lineHeight: 'normal',
                    minWidth: 0,
                }}
                ellipsis
            >
                {title}
            </Text>
            <div
                style={{
                    flexGrow: 1,
                }}
            />
            <Text
                style={{
                    color: antGrey.grey8,
                    fontSize: 12,
                    lineHeight: 'normal',
                }}
                ellipsis
            >
                {value}
            </Text>
        </div>
    );
};
